import React, { useState, useCallback, useEffect } from 'react';
import '../../css/notificationFooter.css';

/**
 * Componente de notificación tipo footer reutilizable
 * Uso:
 * 1. Importar: import NotificationFooter, { showNotification } from './utils/NotificationFooter';
 * 2. Renderizar: <NotificationFooter />
 * 3. Llamar: showNotification('Mensaje', 'success/error/warning/info', duration)
 */

let notificationCallback = null;

// Función global para mostrar notificaciones desde cualquier lugar
export const showNotification = (message, type = 'info', duration = 3000) => {
    if (notificationCallback) {
        notificationCallback(message, type, duration);
    }
};

const NotificationFooter = () => {
    const [message, setMessage] = useState('');
    const [type, setType] = useState('info');
    const [visible, setVisible] = useState(false);

    const show = useCallback((msg, notifType, duration) => {
        setMessage(msg);
        setType(notifType);
        setVisible(true);

        // Auto-ocultar después de la duración especificada
        setTimeout(() => {
            setVisible(false);
            setTimeout(() => setMessage(''), 300); // Limpiar mensaje después de la animación
        }, duration);
    }, []);

    // Registrar callback al montar
    useEffect(() => {
        notificationCallback = show;
        return () => {
            notificationCallback = null;
        };
    }, [show]);

    return (
        <div className={`notification-footer ${visible ? 'visible' : ''} ${type}`}>
            {message}
        </div>
    );
};

export default NotificationFooter;
